import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { useState, useMemo } from 'react'
import useHover from '@hooks/useHover'
import Add from '@material-ui/icons/Add'
import Close from '@material-ui/icons/Close'

import useStyles from './masonry-grid-item.styles'

const MasonryGridItem = (props) => {
  const {
    headline,
    caption,
    image,
    large,
    className,
    index,
  } = props
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'))
  const hasHoverCaption = !!headline || !!caption
  const [hoverRef, isHovered] = useHover()
  const [showMobileCaption, setShowMobileCaption] = useState(false)

  const images = useMemo(() => {
    const dimensions = large ? 'w=1800&h=1200' : 'w=684&h=456'
    return {
      sm: image ? `${image.url}?w=535&h=356&fit=fill&fl=progressive&q=80` : '',
      lg: image ? `${image.url}?${dimensions}&fit=fill&fl=progressive&q=80` : '',
    }
  }, [image])

  const handleClick = () => {
    setShowMobileCaption(!showMobileCaption)
  }

  const styles = useStyles({ images, isHovered, showMobileCaption })

  return (
    <div ref={!isMobile ? hoverRef : null} className={`${styles.root} ${className}`} title={hasHoverCaption ? '' : image?.description || headline}>
      {(hasHoverCaption) && (
        <Box className={styles.captionContainer}>
          {headline && (
            <Typography variant="h5" className={styles.headline}>{headline}</Typography>
          )}
          {caption && (
            <Typography variant="body2">{caption}</Typography>
          )}
        </Box>
      )}
      {(isMobile && hasHoverCaption) && (
        <>
          <Button
            className={styles.captionButton}
            onClick={handleClick}
            aria-label={`${showMobileCaption ? 'hide' : 'reveal'} image caption for image: ${index}`}
          >
            {showMobileCaption ? <Close className={styles.icon} /> : <Add className={styles.icon} />}
          </Button>
        </>
      )}
    </div>
  )
}

MasonryGridItem.propTypes = {
  headline: PropTypes.string,
  caption: PropTypes.string,
  large: PropTypes.bool,
  image: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
  className: PropTypes.string,
  index: PropTypes.number,
}

export default MasonryGridItem
